import { createAction } from "@reduxjs/toolkit";
import {
    GET_CURRENT_USER,
    CURRENT_USER_RECEIVED,
    UPDATE_CURRENT_USER_LANGUAGE,
    GET_CONSTANTS,
    CONSTANTS_RECEIVED,
    GetCurrentUser,
    ReceivedCurrentUser,
    ConstantsReceivedInterface,
    UpdateCurrentUserLanguageInterface
} from "./types";

export const getCurrentUser = createAction<GetCurrentUser["payload"]>(GET_CURRENT_USER);

export const receivedCurrentUser =
    createAction<ReceivedCurrentUser["payload"]>(CURRENT_USER_RECEIVED);

export const getConstants = createAction(GET_CONSTANTS);

export const constantsReceived =
    createAction<ConstantsReceivedInterface["payload"]>(CONSTANTS_RECEIVED);

export const updateCurrentUserLanguage = createAction<
    UpdateCurrentUserLanguageInterface["payload"]
>(UPDATE_CURRENT_USER_LANGUAGE);
